export const MONSTERS = [
  {
    id: "momo",
    sprite: "momo",
    name: "Момо",
    title: "Метаболический спринтер",
    description: "Быстрее растет и может резко ускорить набор массы на короткое время.",
    cardTag: "+22% к росту",
    color: 0xffbd59,
    accent: "#ffbd59",
    cssFilter: '',
    speed: 252,
    growthMultiplier: 1.22,
    widthBonus: 1,
    dashMultiplier: 2.4,
    ability: {
      type: "growth",
      name: "Метаболический шторм",
      hint: "E усиливает набор массы на несколько секунд.",
      cooldown: 12,
      duration: 5,
    },
  },
  {
    id: "vora",
    sprite: "vora",
    name: "Вора",
    title: "Широкая пасть",
    description: "Чуть медленнее, зато раньше всех берется за крупные и широкие здания.",
    cardTag: "+24% к ширине пасти",
    color: 0x7fe0ff,
    accent: "#7fe0ff",
    cssFilter: 'hue-rotate(157deg) saturate(1.3) brightness(1.1)',
    speed: 232,
    growthMultiplier: 1.02,
    widthBonus: 1.24,
    dashMultiplier: 2.55,
    ability: {
      type: "wide",
      name: "Разжим челюстей",
      hint: "E временно добавляет запас к размеру проглатывания.",
      cooldown: 10,
      duration: 4,
    },
  },
  {
    id: "gloop",
    sprite: "gloop",
    name: "Глуп",
    title: "Пылесос района",
    description: "Втягивает мелочь вокруг себя и быстро зачищает улицы у основания роста.",
    cardTag: "Втягивает мелкие объекты",
    color: 0xb6ff7d,
    accent: "#b6ff7d",
    cssFilter: 'hue-rotate(52deg) saturate(1.4) brightness(1.05)',
    speed: 226,
    growthMultiplier: 1.08,
    widthBonus: 1.02,
    dashMultiplier: 2.3,
    ability: {
      type: "vacuum",
      name: "Уличный пылесос",
      hint: "E притягивает доступные мелкие объекты.",
      cooldown: 11,
      duration: 4.5,
      radius: 220,
    },
  },
];

export const SIZE_STAGES = [
  { threshold: 0.9, name: "Карманный вредитель", flavor: "Начало охоты: ешь все уличное." },
  { threshold: 1.7, name: "Переулочный хищник", flavor: "Машины и киоски уже по зубам." },
  { threshold: 2.8, name: "Квартальный кусатель", flavor: "Пора разбирать гаражи и дома." },
  { threshold: 4.2, name: "Бульварный ужас", flavor: "Многоэтажки начинают сдаваться." },
  { threshold: 6.2, name: "Пожиратель горизонта", flavor: "Можно выходить на крупные кварталы." },
  { threshold: 8.6, name: "Пожиратель короны", flavor: "Главная башня почти готова к обеду." },
];

export const OBJECT_TYPES = [
  {
    id: "pedestrian",
    name: "Люди",
    label: "Люди",
    style: "person",
    color: 0xffdc88,
    radius: 14,
    width: 16,
    height: 16,
    requiredSize: 0.9,
    mass: 0.22,
  },
  {
    id: "bin",
    name: "Урны",
    label: "Урны",
    style: "bin",
    color: 0x7fd692,
    radius: 16,
    width: 20,
    height: 20,
    requiredSize: 0.92,
    mass: 0.24,
  },
  {
    id: "fence",
    name: "Заборы",
    label: "Заборы",
    style: "fence",
    color: 0xffb36c,
    radius: 22,
    width: 44,
    height: 12,
    requiredSize: 1.0,
    mass: 0.28,
  },
  {
    id: "lamp",
    name: "Фонари",
    label: "Фонари",
    style: "lamp",
    color: 0xb6f0ff,
    radius: 18,
    width: 18,
    height: 30,
    requiredSize: 1.05,
    mass: 0.34,
  },
  {
    id: "car",
    name: "Машины",
    label: "Машины",
    style: "car",
    color: 0xff8776,
    radius: 28,
    width: 52,
    height: 28,
    requiredSize: 1.32,
    mass: 0.58,
  },
  {
    id: "kiosk",
    name: "Киоски",
    label: "Киоски",
    style: "kiosk",
    color: 0xffd37f,
    radius: 34,
    width: 60,
    height: 44,
    requiredSize: 1.78,
    mass: 0.94,
  },
  {
    id: "garage",
    name: "Гаражи",
    label: "Гаражи",
    style: "garage",
    color: 0x81d6c2,
    radius: 40,
    width: 78,
    height: 54,
    requiredSize: 2.45,
    mass: 1.45,
  },
  {
    id: "house",
    name: "Дома",
    label: "Дома",
    style: "house",
    color: 0x85a8ff,
    radius: 48,
    width: 94,
    height: 74,
    requiredSize: 3.02,
    mass: 2.08,
  },
  {
    id: "midrise",
    name: "Многоэтажки",
    label: "Многоэтажки",
    style: "midrise",
    color: 0xc3a0ff,
    radius: 62,
    width: 120,
    height: 96,
    requiredSize: 4.05,
    mass: 3.18,
  },
  {
    id: "block",
    name: "Кварталы",
    label: "Кварталы",
    style: "block",
    color: 0xff94c7,
    radius: 82,
    width: 158,
    height: 130,
    requiredSize: 5.35,
    mass: 4.7,
  },
  {
    id: "tower",
    name: "Башни",
    label: "Башни",
    style: "tower",
    color: 0xffef8b,
    radius: 98,
    width: 188,
    height: 182,
    requiredSize: 6.95,
    mass: 6.5,
  },
];

export const FINAL_TOWER = {
  id: "crown-tower",
  name: "Главная башня",
  label: "Главная башня",
  style: "crown",
  color: 0xfff0b8,
  radius: 142,
  width: 284,
  height: 284,
  requiredSize: 8.6,
  mass: 14,
  isFinal: true,
};

export const LEVEL_CONFIG = {
  worldWidth: 3200,
  worldHeight: 3200,
  timerSeconds: 150,
  grid: {
    columns: 13,
    rows: 13,
    blockSize: 164,
    roadSize: 34,
  },
};

export const LEVELS = [
  {
    id: 'easy',
    name: 'Районный переполох',
    subtitle: 'Небольшой город • 3 минуты',
    icon: '🏘️',
    worldWidth:   2400,
    worldHeight:  2400,
    timerSeconds: 180,
    grid: { columns: 10, rows: 10, blockSize: 164, roadSize: 34 },
  },
  {
    id: 'medium',
    name: 'Городской разгром',
    subtitle: 'Средний город • 2.5 минуты',
    icon: '🏙️',
    worldWidth:   3200,
    worldHeight:  3200,
    timerSeconds: 150,
    grid: { columns: 13, rows: 13, blockSize: 164, roadSize: 34 },
  },
  {
    id: 'hard',
    name: 'Мегаполис-катастрофа',
    subtitle: 'Огромный город • 2 минуты',
    icon: '🌆',
    worldWidth:   4200,
    worldHeight:  4200,
    timerSeconds: 120,
    grid: { columns: 17, rows: 17, blockSize: 164, roadSize: 34 },
  },
];